export default __webpack_public_path__ + "img/icon-search.b2c0c5c5.svg";